import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "chatbot-wrapper bg-white rounded-lg shadow-lg overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatbotInterface = _resolveComponent("ChatbotInterface")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("div", { class: "flex justify-between items-center mb-2" }, [
        _createElementVNode("h1", { class: "text-2xl font-bold text-blue-900" }, "Chatbot")
      ]),
      _createElementVNode("p", { class: "text-gray-600" }, "AI-powered assistant for airport management tasks")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.userData && _ctx.userData?.id)
        ? (_openBlock(), _createBlock(_component_ChatbotInterface, {
            key: 0,
            userData: _ctx.userData,
            environment: _ctx.currentEnv,
            userId: _ctx.userData?.id,
            class: "h-full"
          }, null, 8, ["userData", "environment", "userId"]))
        : _createCommentVNode("", true)
    ])
  ]))
}